export default "__VITE_ASSET__DtQ7vOFJ__"